import * as messageService from "../../services/message.service";
import * as dashboardDealerService from '../../services/dashboardDealer.service';

const state = {
    dDealerData:[],
    dDealerThisMonthData:[],
    dDealerLastMonthData:[],
    dDealerThisYearData:[],
    dDealerLastYearData:[],
};

const getters = {
    gettDDealerData:state => (state.dDealerData),
    gettDDealerThisMonthData:state => (state.dDealerThisMonthData),
    gettDDealerLastMonthData:state => (state.dDealerLastMonthData),
    gettDDealerThisYearData:state => (state.dDealerThisYearData),

    gettDDealerLastYearData:state => (state.dDealerLastYearData),
};

const actions = {
    async fetchDDealerData({ commit }, dealerId ){
        try {
            const response = await dashboardDealerService.all(dealerId);
            commit('setDDealerData', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDDealerThisMonthData({ commit }, dealerId ){
        try {
            const response = await dashboardDealerService.thisMonth(dealerId);
            commit('setDDealerThisMonthData', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDDealerLastMonthData({ commit }, dealerId ){
        try {
            const response = await dashboardDealerService.lastMonth(dealerId);
            commit('setDDealerLastMonthData', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    // async fetchDDealerThisYearData({ commit }, dealerId ){
    //     try {
    //         const response = await dashboardDealerService.thisYear(dealerId);
    //         commit('setDDealerThisYearData', response.data);
    //     } catch (error) {
    //         const obj = {
    //             "type":'error',
    //             "title":error.response.data.error.name,
    //             "text":error.response.data.error.message,
    //             "footer":'Error code: ' + error.response.data.error.statusCode,
    //         }

    //         messageService.fnSweetAlertDisplay(obj);
    //     }
    // },

    //need this
    async fetchDDealerLastYearData({ commit }, dealerUserId ){
        try {
            const response = await dashboardDealerService.lastYear(dealerUserId);
            commit('setDDealerLastYearData', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setDDealerData:(state, res) => (
        state.dDealerData =  res
    ),
    setDDealerThisMonthData:(state, res) => (
        state.dDealerThisMonthData =  res
    ),
    setDDealerLastMonthData:(state, res) => (
        state.dDealerLastMonthData =  res
    ),
    setDDealerThisYearData:(state, res) => (
        state.dDealerThisYearData =  res
    ),
    setDDealerLastYearData:(state, res) => (
        state.dDealerLastYearData =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}